/* eslint-disable */
import a from './p.js'
import r1 from './r1.js'

var s = function (e) {
  function i(e, t, n) {
    return function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i),
      function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this, e, t, n))
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(i, a.default),
    r1(i, [{
      key: "render",
      value: function (e) {
        this.mouseRatio.x = window.mouse.x / this.image.width * 2 - 1,
          this.nMouse.x += (this.mouseRatio.x * this.intensity - this.nMouse.x) * this.smooth,
          this.material.uniforms.u_mouse.value = this.nMouse
      }
    }, {
      key: "dispose",
      value: function () {
        this.mouseRatio = null,
          this.nMouse = null,
          this.material = null
      }
    }]),
    i
}();
var t = { default: s }

export default t
